import { TrendingUp, DollarSign, Eye, MousePointerClick } from 'lucide-react'
import type { FunnelAnalytics } from '../../types'

interface QuickStatsProps {
  analytics: FunnelAnalytics
}

export function QuickStats({ analytics }: QuickStatsProps) {
  const stats = [
    {
      label: 'Impressions',
      value: analytics.impressions.toLocaleString(),
      icon: Eye,
      color: 'var(--fn-primary)',
    },
    {
      label: 'Conversions',
      value: analytics.conversions.toLocaleString(),
      icon: MousePointerClick,
      color: 'var(--fn-status-success)',
    },
    {
      label: 'Conv. Rate',
      value: `${analytics.conversionRate.toFixed(1)}%`,
      icon: TrendingUp,
      color: 'var(--fn-status-warning)',
    },
    {
      label: 'Revenue',
      value: `$${(analytics.revenue / 1000).toFixed(1)}k`,
      icon: DollarSign,
      color: 'var(--fn-status-info)',
    },
  ]

  return (
    <div
      className="rounded-lg border p-4"
      style={{
        borderColor: 'var(--fn-border)',
        backgroundColor: 'var(--fn-bg-card)',
      }}
    >
      <h3 className="text-sm font-semibold mb-3 text-fn-text">
        Quick Stats
        <span className="text-xs font-normal ml-2 text-fn-text-muted">
          (Last 30 days)
        </span>
      </h3>

      <div className="grid grid-cols-2 gap-3">
        {stats.map((stat) => {
          const Icon = stat.icon
          return (
            <div
              key={stat.label}
              className="p-3 rounded border"
              style={{
                borderColor: 'var(--fn-border)',
                backgroundColor: 'var(--fn-bg-hover)',
              }}
            >
              <div className="flex items-center gap-2 mb-1">
                <Icon className="w-4 h-4" style={{ color: stat.color }} />
                <p className="text-xs text-fn-text-muted">
                  {stat.label}
                </p>
              </div>
              <p className="text-lg font-semibold text-fn-text">
                {stat.value}
              </p>
            </div>
          )
        })}
      </div>
    </div>
  )
}
